import { useEffect, useState } from "react"


const MinimumForecastDropdown = ({ searchParams, setSearchParams, minforecastOptions }) => {

  const [forecastOptions, setForecastOptions] = useState([])
  useEffect(() => {
    setForecastOptions(minforecastOptions.map(t => t.value).sort((a, b) => a - b))
  }, [minforecastOptions])

  return <select value={searchParams.get("min-forecast")}
    onChange={e => {
      setSearchParams(prev => {
        prev.set("min-forecast", e.target.value)
        return prev
      })
    }}
    className="rounded p-1 mx-2 text-center"
  >
    <option value={""} disabled>Min Forecast</option>
    {forecastOptions.map(o => <option value={o} key={o}>{o}</option>)}

  </select>

}

export default MinimumForecastDropdown
